const getRemainingTime = (date) => {
  const _second = 1000;
  const _minute = _second * 60;
  const _hour = _minute * 60;
  const _day = _hour * 24;

  const now = new Date();
  const distance = date - now;

  if (distance < 0) {
      return null;
  }

  const days = Math.floor(distance / _day);
  const hours = Math.floor((distance % _day) / _hour);
  const minutes = Math.floor((distance % _hour) / _minute);
  const seconds = Math.floor((distance % _minute) / _second);

  return { days, hours, minutes, seconds };
}

export default getRemainingTime;